import { mapState } from 'vuex'

export default {
  methods: {
    async initPlatinumData () {
      this.$store.commit('SET_PLATINUM_SUBDOMAIN', {
        subdomain: this.platinumSlug ?? ''
      })

      await this.$store.dispatch('institution/getInstitutionPlatinumBySubdomain')
    }
  },
  computed: {
    ...mapState(['isPrakerja']),
    platinumSlug () {
      return this.$route.query.subdomain_slug ?? ''
    },
    logoUrl () {
      if (window.location.origin.includes('prakerja')) {
        return window.location.origin
      }

      let homeUrl = ''
      const slug = this.isPrakerja
        ? 'prakerja'
        : this.platinumSlug !== ''
          ? this.platinumSlug
          : 'www'

      const queryParams = new URLSearchParams(this.$route.query)
      const queries = queryParams.toString() ? `?${queryParams.toString()}` : ''

      switch (this.activeEnv) {
        case 'localhost':
          if (this.isPrakerja) {
            homeUrl = `${process.env.VUE_APP_URL_REWRITE_PRAKERJA}${queries}`
          } else {
            homeUrl = `${process.env.VUE_APP_URL_REWRITE}${queries}`
          }
          break
        case 'development':
          homeUrl = `https://${slug}.dev.karier.mu${queries}`
          break
        case 'staging':
          homeUrl = `https://${slug}.staging.karier.mu${queries}`
          break
        case 'production':
        default:
          homeUrl = `https://${slug}.karier.mu${queries}`
          break
      }
      return homeUrl
    },
    queryParam () {
      if (this.platinumSlug) {
        return `?subdomain_slug=${this.platinumSlug}`
      }
      return ''
    },
    activeEnv () {
      return this.$store.state.activeEnv
    },
    envPlatinum () {
      return Boolean(this.platinumSlug)
    },
    platinumInstitutionInfo () {
      return this.$store.state.institution.platinumInstitutionInfo
    },
    logoSrcUrl () {
      return this.envPlatinum ? this.platinumInstitutionInfo.logo_2 : 'https://cdn.karier.mu/kariermu/assets/logo/kariermu-2023.webp'
    }
  },
  watch: {
    queryParam (value) {
      if (!this.platinumInstitutionInfo.logo) {
        this.initPlatinumData()
      }
    }
  },
  created () {
    if (this.platinumSlug) {
      this.initPlatinumData()
    }
  }
}
